import { Router } from "../router";

export const router = new Router<any>();

router.on("project_terminal_sessions", (data, ctx) => {
    ctx.terminal.syncSessions(data.sessions ?? []);
});
